// extracted by mini-css-extract-plugin
module.exports = {"SM":"360px","MD":"640px","LG":"1200px","Paragraph":"Finish_Paragraph__1iKAH"};